import React from 'react'

export default [
  {
    title: 'Los Angeles',
    contents: (
      <div>
        <p className="t-h3">Corporate Headquarters</p>
        <p className="t-p mt10">
          AmericanTours International, LLC. L.A. International Airport<br />{' '}
          6033 W Century Blvd, STE 900, Los Angeles, CA 90045
        </p>
        <ul className="mt10">
          <li>Phone: (310) 641-9953</li>
          <li>Fax: (310) 216-5807</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Orlando',
    contents: (
      <div>
        <p className="t-p mt10">
          AmericanTours International, LLC.<br />{' '}
          5787 Vineland Road #207, Orlando, FL 32819
        </p>
        <ul className="mt10">
          <li>Phone: (407) 370-3701</li>
          <li>Fax: (407) 370-6928</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'New York',
    contents: (
      <div>
        <p className="t-p mt10">
          AmericanTours International, LLC. The New Yorker Hotel<br />{' '}
          481 Eighth Avenue Suite 605, New York, NY 10001
        </p>
        <ul className="mt10">
          <li>Phone: (212) 586-4100</li>
          <li>Fax: (212) 586-2225</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Honolulu',
    contents: (
      <div>
        <p className="t-p mt10">
          AmericanTours International, LLC. Galleria Waikiki Office Tower<br />{' '}
          2222 Kalakaua Ave, Suite 1007, Honolulu, HI 96815
        </p>
        <ul className="mt10">
          <li>Phone: (808) 922-2841</li>
          <li>Fax: (808) 924-8486</li>
        </ul>
      </div>
    ),
  }
]



// WEBPACK FOOTER //
// ./src/contactLocations.js